import { AUTHORING_DOWNLOAD_FILENAME } from '../config'

/**
 * Browser persistence helpers for the authoring annotation JSON.
 */
export function readStoredAuthoringAnnotations(
  storage,
  storageKey,
  fallbackStorageKeys = []
) {
  const keys = [storageKey, ...fallbackStorageKeys].filter(Boolean)
  const raw = keys.map(key => storage.getItem(key)).find(Boolean)
  return raw ? JSON.parse(raw) : null
}

export function writeStoredAuthoringAnnotations(
  storage,
  storageKey,
  annotations
) {
  storage.setItem(storageKey, JSON.stringify(annotations))
}

export function downloadAnnotationJson(
  annotations,
  documentRef = document,
  urlRef = URL
) {
  const blob = new Blob([JSON.stringify(annotations, null, 2)], {
    type: 'application/json',
  })
  const link = documentRef.createElement('a')
  link.href = urlRef.createObjectURL(blob)
  link.download = AUTHORING_DOWNLOAD_FILENAME
  documentRef.body.appendChild(link)
  link.click()
  documentRef.body.removeChild(link)
  urlRef.revokeObjectURL(link.href)
}
